module.exports = __webpack_public_path__ + "6f7f60a88528468c930894585a4a983f.svg";